import React from 'react';
import PageBreadcrumb from '../components/PageBreadcrumb';

const stories = [
    {
        title: 'From Dropout to Developer',
        text: 'Through YAP digital labs, a student from rural KP completed full-stack training and now mentors younger learners in his district.',
    },
    {
        title: 'Women-Led Micro Enterprise',
        text: 'A local women group scaled a small stitching initiative into a neighborhood business after vocational and finance coaching.',
    },
    {
        title: 'Community Learning Hub',
        text: 'A volunteer-led study center now supports 200+ children every week with literacy, science basics, and confidence-building sessions.',
    },
];

const ImpactStories = () => (
    <div className="bg-slate-50">
        <PageBreadcrumb
            title="Impact Stories"
            description="Real outcomes from communities we serve."
            items={[{ label: 'Impact Stories' }]}
        />
        <section className="mx-auto grid max-w-7xl gap-6 px-4 py-14 md:grid-cols-3">
            {stories.map((story) => (
                <article key={story.title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-xl">
                    <h2 className="text-xl font-bold text-slate-800">{story.title}</h2>
                    <p className="mt-3 text-slate-600">{story.text}</p>
                </article>
            ))}
        </section>
    </div>
);

export default ImpactStories;
